<template>
  <div>
    <div class="pdf-preview" v-if="pdfFile">
      <button @click.self="closePreview()">
        &times;
    </button>

    <iframe
      :src="pdfFile"
      width="100%"
      height="100%"
    />
    </div>
    <div v-show="false">
        <div ref="testHtml">
          <div v-for="page in totalPages" :key="page" class="mx-5 my-4">
            <div class="pdf-item mb-3 d-flex text-xs justify-content-between">
              <div>
                <img
                  src="../assets/gunter_Logo-bg.png"
                  alt="Logo"
                  style="flex: none;"
                  height="30"
                  width="30"
                />
                <h4
                class="text-sm"
                >
                  GUNTER SHIPPING
                  <br/>
                  1100 LINWOOD
                  <br/>
                  BROOKLYN, NEW YORK 11208
                  <br>
                  Tel : 718-671-2000
                  <br>
                  Email: CUSTSVC@GUNTERSHIPPING.COM
                </h4>
              </div>
              <div class="text-xl font-weight-bold">
                <div>
                  WAREHOUSE RECEIPT
                </div>
              </div>
            </div>
          <div class="pdf-item d-flex text-sm justify-content-between">
            <div>
                RECEIVED FOR:
                <h4
                class="text-sm"
                >
                {{ response.consignee.firstName.toUpperCase() }}
                {{ response.consignee.lastName.toUpperCase() }}
                <br/>
                {{ response.consignee.address.toUpperCase() }}
                <br/>
                {{ response.consignee.city.toUpperCase() }},
                {{ response.consignee.state.toUpperCase() }}
                {{ response.consignee.zipCode }}
                <br/>
                Tel: {{ response.consignee.phone }}
                </h4>
            </div>
            <div>
              <table class="table table-bordered text-xs w-100" style="line-height: 0;">
                  <tr>
                    <th>ACCOUNT</th>
                    <th>NUMBER</th>
                  </tr>
                  <tr>
                    <td>
                      GUNTER SHIPPING
                    </td>
                    <td>
                      {{ response.id }}
                    </td>
                  </tr>
                  <tr>
                    <th>DATE</th>
                    <th>PIECES</th>
                  </tr>
                  <tr>
                    <td>
                      {{ response.pickupDetails.pickupStartTime }}
                    </td>
                    <td>
                      {{ totalPackage }}
                    </td>
                  </tr>
                  <tr>
                    <th>GROSS WEIGHT</th>
                    <th>CUBIC</th>
                  </tr>
                  <tr>
                    <td>
                      {{ totalWeight('lb') }} LBS
                    </td>
                    <td>
                      {{ totalVolume('ft') }} CF
                    </td>
                  </tr>
                  <tr>
                    <th colspan="2">REFERENCE</th>
                  </tr>
                  <tr>
                    <td colspan="2">
                    </td>
                  </tr>
                </table>
            </div>
          </div>

          <div class="pdf-item mb-2">
            <table class="table table-bordered text-sm w-100" style="line-height: 0;">
              <tr>
                <th>RECEIVED FROM</th>
                <th>DELIVERED BY</th>
                <th>TRACKING NUMBER</th>
              </tr>
              <tr>
                <td>
                  {{ response.shipper.firstName.toUpperCase() }}
                  {{ response.shipper.lastName.toUpperCase() }}
                </td>
                <td>
                  <div v-if="response.pickupDetails.pickupMode">
                  {{ response.pickupDetails.pickupMode.toUpperCase() }}
                  </div>
                  <div v-else>
                    {{ response.pickupDetails.pickupMode }}
                  </div>
                </td>
                <td>
                </td>
              </tr>
              <tr>
                <th>FREIGHT RECEIVED</th>
                <th colspan="2">ORGIN/DESTINATION</th>
              </tr>
              <tr>
                <td>
                  COLLECT
                </td>
                <td colspan="2">
                  {{ response.shipper.airportCode.toUpperCase() }} /
                  {{ response.consignee.airportCode.toUpperCase() }}
                </td>
              </tr>
              <tr>
                <th colspan="3">PICKUP NOTES</th>
              </tr>
              <tr>
                <td colspan="3">
                  <div class="pdf-item mb-3 d-flex text-xs justify-content-between">
                    <div>
                      {{ response.pickupDetails.pickupNote.toUpperCase() }}
                    </div>
                    <div class="text-xl font-weight-bold">
                      <div v-if="response.itemDetails.travelMode">
                        {{ travelMode(response.itemDetails.travelMode).toUpperCase() }}
                      </div>
                      <div v-else>
                        {{ travelMode(response.itemDetails.travelMode) }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <div class="pdf-item d-flex text-sm justify-content-between">
            <div>
              <table width="500" height="400" class="table-bordered text-xs text-center"
              style="line-height: 0;">
                  <tr>
                    <th>PIECES</th>
                    <th>TYPE</th>
                    <th>LENGTH</th>
                    <th>WIDTH</th>
                    <th>HEIGHT</th>
                    <th>WEIGHT</th>
                    <th></th>
                    <th>VOLUME</th>
                    <th>DESCRIPTION</th>
                  </tr>
                  <tr v-for="(item) in paginatedData(page-1)"
                    :key="item.id">
                    <td>{{ item.qty }}</td>
                    <td>{{ item.packageType.toUpperCase() }}</td>
                      <td>{{ item.length }}</td>
                      <td>{{ item.width }}</td>
                      <td>{{ item.height }}</td>
                      <td>{{ item.weight }}</td>
                      <td>{{ item.selectedWeightType }}</td>
                      <td>{{ item.volume }}</td>
                      <td>{{ item.description }}</td>
                  </tr>
              </table>
            </div>
            <div>
              <div class="text-xl font-weight-bold text-center">
                $ {{ totalPayment }}
              </div>
              <table class="table table-bordered text-xs text-right w-100" style="line-height: 0;">
                <tr>
                  <th colspan="2">PIECES</th>
                </tr>
                <tr>
                  <td colspan="2">
                    {{ totalPackage }}
                  </td>
                </tr>
                <tr>
                  <th>POUNDS</th>
                  <th>KILOS</th>
                </tr>
                <tr>
                  <td>
                    {{ totalWeight('lb') }}
                  </td>
                  <td>
                    {{ totalWeight('kg') }}
                  </td>
                </tr>
                <tr>
                  <th>CUBIC FEET</th>
                  <th>CUBIC METERS</th>
                </tr>
                <tr>
                  <td>
                    {{ totalVolume('ft') }}
                  </td>
                  <td>
                    {{ totalVolume('m') }}
                  </td>
                </tr>
                <tr>
                  <th colspan="2">CHARG WEIGHT</th>
                </tr>
                <tr>
                  <td colspan="2">
                    {{ totalWeight('lb') }}
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="pdf-item mb-2">
            <table class="table table-bordered text-xs w-100">
                <tr>
                  <th>REMARKS</th>
                </tr>
                <tr>
                <td>
                  <div class="text-xs">
                    {{ response.pickupDetails.pickupRemark }}
                  </div>
                  <span v-if="seals.length !== 0">SEAL</span>
                  <span class="text-xs" v-for="(seal, index) in seals" :key="index">
                    <!-- {{ seal }}
                    <span v-if="index !== seals.length - 1">/</span> -->
                    <span v-if="seal">
                      <span v-if="index !== seals.length & index != 0">/</span>
                      {{ seal }}
                    </span>
                  </span>
                  <div class="text-xs">
                    CREATED BY:
                    {{ currentUser.firstName.toUpperCase() }}
                    {{ currentUser.lastName.toUpperCase() }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div v-if="page < totalPages" class="html2pdf__page-break" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
  name: 'PdfTest',
  props: [
    'name',
    'response',
    'currentUser',
  ],
  data() {
    return {
      pdfFile: null,
      seen: {},
      size: 15,
      travelModes: [
        { value: null, text: '' },
        { value: 'oceanDirect', text: 'Ocean Direct' },
        { value: 'oceanTranshipment ', text: 'Ocean Transshipment' },
        { value: 'air', text: 'Air' },
        { value: 'ground', text: 'Ground' },
      ],
    };
  },
  computed: {
    hazardous() {
      return this.response.itemDetails.items.reduce((acc, item) => acc || item.hazardous, false);
    },
    totalPayment() {
      return this.response.payments.reduce((acc, curr) => acc + curr.amount, 0);
    },
    totalPages() {
      return Math.ceil(this.response.itemDetails.items.length / this.size);
    },
    totalPackage() {
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.qty, 0);
    },
    seals() {
      const seals = this.response.itemDetails.items.map((item) => item.seal);
      const flattenseals = seals.flat().map((seal) => seal.value);
      return flattenseals;
    },
    // filteredArr() {
    //   this.reset();
    //   const filter = this.response.itemDetails.items.filter((el) => {
    //     if (el.packageType === '') {
    //       return false;
    //     }
    //     const duplicate = this.seen[el.packageType] !== undefined;
    //     if (duplicate) {
    //       this.seen[el.packageType] += 1;
    //     } else {
    //       this.seen[el.packageType] = 1;
    //     }
    //     return !duplicate;
    //   });
    //   return filter;
    // },
    // filteredArr() {
    //   const result = [];
    //   this.response.itemDetails.items.forEach((item) => {
    //     const resObj = result.find((obj) => obj.packageType === item.packageType
    //       && obj.length === item.length && obj.width === item.width
    //       && obj.height === item.height && obj.weight === item.weight);
    //     if (resObj) {
    //       resObj.count += 1;
    //     } else {
    //       result.push({ ...item, count: 1 });
    //     }
    //   });
    //   return result;
    // },
  },
  methods: {
    // lower(response) {
    //   const copy = Object.keys(response).reduce((acc, curr) => {
    //     if (response[curr] == null) {
    //       acc[curr] = response[curr];
    //     } else if (typeof response[curr] === 'string') {
    //       acc[curr] = response[curr].toLowerCase().trim();
    //     } else if (Array.isArray(response[curr])) {
    //       acc[curr] = this.arrayLower(response[curr]);
    //     } else if (typeof response[curr] === 'object') {
    //       acc[curr] = this.lower(response[curr]);
    //     } else {
    //       acc[curr] = response[curr];
    //     }
    //     return acc;
    //   }, {});
    //   return copy;
    // },
    // arrayLower(response) {
    //   const copy = Object.keys(response).reduce((acc, curr) => {
    //     if (response[curr] == null) {
    //       acc[curr] = response[curr];
    //     } else if (typeof response[curr] === 'string') {
    //       acc[curr] = response[curr].toLowerCase().trim();
    //     } else if (Array.isArray(response[curr])) {
    //       acc[curr] = this.arrayLower(response[curr]);
    //     } else if (typeof response[curr] === 'object') {
    //       acc[curr] = this.lower(response[curr]);
    //     } else {
    //       acc[curr] = response[curr];
    //     }
    //     return acc;
    //   }, []);
    //   return copy;
    // },
    travelMode(value) {
      const type = this.travelModes.find((mode) => mode.value === value);
      if (type) {
        return type.text;
      }
      return '';
    },
    totalWeight(type) {
      const weight = this.response.itemDetails.items.reduce(
        (acc, curr) => acc + curr.weight * curr.qty,
        0,
      );
      if (type === 'lb') {
        return parseFloat(weight).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(weight / 2.2046).toFixed(3).replace(/\.000$/, '');
    },
    totalVolume(type) {
      const volume = this.response.itemDetails.items.reduce(
        (acc, curr) => acc + curr.volume * curr.qty, 0,
      );
      if (type === 'ft') {
        return parseFloat(volume / 1728).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(volume / 61023.7441).toFixed(3).replace(/\.000$/, '');
    },
    paginatedData(page) {
      const start = page * this.size;
      const end = start + this.size;
      const paginated = this.response.itemDetails.items.slice(start, end);
      while (paginated.length < this.size) {
        paginated.push({
          packageType: '',
          description: '',
          weight: '',
          volume: '',
          length: '',
          height: '',
          width: '',
          seal: '',
          hazardous: false,
          flag: true,
          selectedWeightType: '',
          optionsWeightType: [
            { value: 'lbs', text: 'lbs' },
          ],
          selectedVolumeType: 'in3',
          optionsVolumeType: [
            { value: 'in3', text: 'in3' },
          ],
          selectedMeasureType: 'in',
          optionsMeasureType: [
            { value: 'in', text: 'in' },
          ],
        });
      }
      return paginated;
    },
    currentDateTime() {
      const today = new Date();
      return today.toLocaleDateString('en-US');
      // need to update
    },
    reset() {
      this.seen = {};
    },
    closePreview() {
      this.pdfFile = null;
    },
    generatePdf() {
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      // const doc = new jsPDF('p', 'pt', 'A4');
      // const margins = {
      //   top: 80,
      //   bottom: 60,
      //   left: 40,
      //   width: 522,
      // };

      // doc.html(this.$refs.testHtml, { left: margins.left, width: margins.width }).then(() => {
      //   doc.output('dataurlnewwindow');
      // });
      const opt = {
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          dpi: 300,
          scale: 4,
        },
      };

      html2pdf().from(this.$refs.testHtml).set(opt).output('bloburl')
        .then((ref) => {
          this.pdfFile = ref;
        });
    },
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
};
</script>

<style lang="scss" scoped>
 body {
  font-family: Helvetica;
}
li:not(:last-child) {
    // margin-bottom: 5px;
    margin-bottom: 1px;
}
.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
}

.smalltext {
  font-size: 0.55rem;
  line-height: .8rem;
}

.pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;

  button {
    position: absolute;
    top: -20px;
    left: -15px;
    width: 35px;
    height: 35px;
    background: #555;
    border: 0;
    box-shadow: 0px 0px 10px #00000048;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
  }

  iframe {
    border: 0;
  }

}

</style>
